import {
  Viewer,
  CallbackProperty,
  Color,
  PolylineDashMaterialProperty,
} from "cesium";

export function createMaterialMarchingAnts(viewer: Viewer) {
  let lastUpdate = -1;
  let patternAnimationIndex = 0.0;

  const varyingDashPattern = new CallbackProperty((time, result) => {
    viewer.scene.requestRender();
    const now = new Date().getTime();
    const deltaT = (lastUpdate < 0 ? 0 : now - lastUpdate) / 1000.0;
    lastUpdate = now;
    patternAnimationIndex += deltaT * 24.0;
    while (patternAnimationIndex >= 16) patternAnimationIndex -= 16.0;
    const idx = Math.floor(patternAnimationIndex);
    const x = rotateAntsRight(255.0, -idx);
    return x;
  }, false);

  return new PolylineDashMaterialProperty({
    color: Color.WHITE,
    dashLength: 16.0,
    dashPattern: varyingDashPattern,
  });
}

function rotateAntsRight(value: number, count: number) {
  if (count < 0) return rotateAntsLeft(value, -count);
  count %= 16;
  return (value << count) | (value >> (16 - count));
}

function rotateAntsLeft(value: number, count: number) {
  if (count < 0) return rotateAntsRight(value, -count);
  count %= 16;
  return (value >> count) | (value << (16 - count));
}
